import { z } from 'zod';

import { ApiResponse } from '@/modules/common/types/dto/response/api-response';
import { PaginatedResponse } from '@/modules/common/types/pagination-types';
import { BaseOnboardingEntity } from '@/modules/onboarding/common/types/base-onboarding-entity';
import { ProjectStatus } from '@/modules/projects/types/project';

import { Client } from '../../clients-setup/types/clients.types';
import { getProjectsSchema } from '../constants';

export enum ProjectDataReconciliationQueryKeys {
  Projects = 'projects-data-reconciliation',
  ValidationReport = 'projects-validation-report',
}

export interface Project extends BaseOnboardingEntity {
  client?: Pick<Client, 'id' | 'name'>;
  status: ProjectStatus;
  archivedDate: Date;
}

export enum ProjectFields {
  Id = 'id',
  Name = 'name',
  ClientId = 'clientId',
}

export interface ProjectsApiData extends PaginatedResponse<Project> {}

export type ProjectsFormData = z.infer<ReturnType<typeof getProjectsSchema>>;

export type CreateProjectsFormData = z.infer<ReturnType<typeof getProjectsSchema>> & {
  projects: Array<
    Omit<z.infer<ReturnType<typeof getProjectsSchema>>['projects'][number], typeof ProjectFields.Id>
  >;
};

export class ProjectsApiResponse extends ApiResponse<ProjectsApiData> {}
